import React, { useContext, useEffect, useRef, useState } from "react";
import "../../styles/styles.css";
import PatientDetails from "../Overlays/PatientDetails";
import StudyDetails from "../Overlays/StudyDetails";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import SeriesDetails from "../Overlays/SeriesDetails";
import $ from "jquery";
import {
  enableVOISync,
  getInitialZoomForMPR,
  getMPRViewport,
  getSliceData,
  loadMPR,
  setToolOnActiveMPRViewport,
  updateOrientationMarkers,
} from "../../helpers/CornerstoneViewportService";
import DICOMDetails from "../Overlays/DICOMDetails";
import { Enums } from "@cornerstonejs/core";
import { windowLevel, jumpToSlice } from "@cornerstonejs/core/utilities";
import ImageScrollbar from "../Scrollbar/ImageScrollbar";
import { WindowLevelTool } from "@cornerstonejs/tools";
import { isReconstructable } from "../../helpers/MPRService";
import { useTranslation } from "react-i18next";
import { MPRViewportsId } from "../../helpers/MPRViewportInput";
import OrientationMarkers from "../Overlays/OrientationMarkers";
import toastContext from "../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../constants/Constants";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import ContextMenu from "../../helpers/ContextMenu";
import {
  cine
} from "@cornerstonejs/tools/utilities";
import CINEPauseSmall from "../../../../components/SVGComponents/Tools/CINEPauseSmall";
import CINEPlaySmall from "../../../../components/SVGComponents/Tools/CINEPlaySmall";
import CINEMinus from "../../../../components/SVGComponents/Tools/CINEMinus";
import CINEPlus from "../../../../components/SVGComponents/Tools/CINEPlus";
import Spinner from "../../../../components/Spinner/Spinner";
import { getEnabledElement } from '@cornerstonejs/core';
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";

const MPRViewport = ({ orientation, viewportIndex ,setInitialVOI}) => {
  // const [seriesData, setSeriesData] = useState({});
  const [voi, setVOI] = useState({ windowCenter: null, windowWidth: null });
  const [scale, setScale] = useState(1);
  const { activeMPRThumbnailIndex, setActiveMPRThumbnailIndex } =
    useContext(ThumbnailContext);
  const {
    isMPRActive,
    viewportSeriesData,
    activeViewportIndex,
    mprViewportElements,
    activeMPRViewportIndex,
    activeMPRTool,
    setActiveMPRTool,
    setActiveMPRViewportIndex,
    showOverlay,
    previousActiveMPRTool,
    setIsMPRActive,
    setMprLoading,
    mprSeriesData,
    setMprSeriesData,
    contextMenuOpen,
    isMPRCineEnabled,
    setMprViewportElements,
    setIsMPRViewportActivated,
    isMPRViewportActivate,
    mprViewportLoaderRunning,
    setMPRViewportLoaderRunning,
    setVolumeId,
    volumeId,
    sharedSlabThickness,
    setSharedSlabThickness,
    sharedMprBlendMode,
    setSharedMprBlendMode,
  } = useContext(ViewportContext);
  const {isEnabledSlabThickness} = useContext(studyviewerContext);
  const { t } = useTranslation();
  const [imageCount, setImageCount] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [scrollbarHeight, setScrollbarHeight] = useState("100px");
  const [markers, setMarkers] = useState({});
  const elementRef = useRef();
  const { showToastv2 } = useContext(toastContext);
  const [cINEFramesPerSecond, setCINEFramesPerSecond] = useState(7);
  const [viewportLevelCINEEnabled, setViewportLevelCINEEnabled] =
    useState(true);

  useEffect(() => {
    if (isMPRActive) {
      setToolOnActiveMPRViewport(
        viewportIndex,
        activeMPRTool,
        previousActiveMPRTool,
        activeMPRViewportIndex
      );
    }
  }, [activeMPRTool]);

  useEffect(() => {
    setMprSeriesData(viewportSeriesData[activeViewportIndex]);
  }, [isMPRActive]);

  useEffect(() => {
    const sbHeight = `${elementRef.current.clientHeight - 23}px`;
    setScrollbarHeight(sbHeight);
  }, [elementRef, isMPRActive]);

  useEffect(() => {
    const updateVOI = (event) => {
      const { range } = event.detail;

      if (!range) {
        return;
      }

      const { lower, upper } = range;
      const { windowWidth, windowCenter } = windowLevel.toWindowLevel(
        lower,
        upper
      );

      setVOI({ windowCenter, windowWidth });
    };

    mprViewportElements[orientation]?.addEventListener(
      Enums.Events.VOI_MODIFIED,
      updateVOI
    );

    return () => {
      mprViewportElements[orientation]?.removeEventListener(
        Enums.Events.VOI_MODIFIED,
        updateVOI
      );
    };
  }, [mprViewportElements]);
  
  useEffect(() => {
    if (
      mprViewportElements["axial"] &&
      mprViewportElements["coronal"] &&
      mprViewportElements["sagittal"]
    ) {
      console.log("MPR ready, applying initial mode:", sharedMprBlendMode);
      updateBlendMode(sharedMprBlendMode);
    }
  }, [mprViewportElements]);
  
  const updateInitialVOI = async (range) => {
    const { lower, upper } = range;
      const { windowWidth, windowCenter } = windowLevel.toWindowLevel(
        lower,
        upper
      );

      setVOI({ windowCenter, windowWidth });
  };

  useEffect(() => {
    const getOrientationMarkers = async (event) => {
      getSliceData(viewportIndex, setImageCount, setCurrentImage);
      const m = await updateOrientationMarkers(
        event,
        MPRViewportsId[viewportIndex]
      );
      setMarkers(m);
      setMPRViewportLoaderRunning(false);
      
      // const m = await updateOrientationMarkers(
      //   event,
      //   MPRViewportsId[viewportIndex]
      // );
      // setMarkers(m);
    };

    mprViewportElements[orientation]?.addEventListener(
      Enums.Events.IMAGE_RENDERED,
      getOrientationMarkers
    );

    return () => {
      mprViewportElements[orientation]?.removeEventListener(
        Enums.Events.IMAGE_RENDERED,
        getOrientationMarkers
      );
    };
  });

  useEffect(() => {
    window.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
  }, []);

  useEffect(() => {
    const getInitialZoom = async (event) => {
      getInitialZoomForMPR(viewportIndex, setScale);
      if(voi.windowCenter === null && voi.windowWidth === null) {
        const viewport = await getMPRViewport(viewportIndex);
        if(viewport.getProperties(volumeId)?.voiRange) {
          updateInitialVOI(viewport.getProperties(volumeId).voiRange);
        }
      }

    };

    mprViewportElements[orientation]?.addEventListener(
      Enums.Events.CAMERA_MODIFIED,
      getInitialZoom
    );

    return () => {
      mprViewportElements[orientation]?.removeEventListener(
        Enums.Events.CAMERA_MODIFIED,
        getInitialZoom
      );
    };
  }, [mprViewportElements]);

  useEffect(() => {
    const getInitialZoomAndOrientation = async (event) => {
      getInitialZoomForMPR(viewportIndex, setScale);
      const m = await updateOrientationMarkers(
        event,
        MPRViewportsId[viewportIndex]
      );
      setMarkers(m);
    };

    mprViewportElements[orientation]?.addEventListener(
      Enums.Events.VOLUME_VIEWPORT_NEW_VOLUME,
      getInitialZoomAndOrientation
    );

    return () => {
      mprViewportElements[orientation]?.removeEventListener(
        Enums.Events.VOLUME_VIEWPORT_NEW_VOLUME,
        getInitialZoomAndOrientation
      );
    };
  }, [mprViewportElements]);

  useEffect(() => {
    const fetchSliceData = (event) => {
      setTimeout(() => {
        getSliceData(viewportIndex, setImageCount, setCurrentImage);
      }, 1000);
    };

    mprViewportElements[orientation]?.addEventListener(
      Enums.Events.VOLUME_VIEWPORT_NEW_VOLUME,
      fetchSliceData
    );

    return () => {
      mprViewportElements[orientation]?.removeEventListener(
        Enums.Events.VOLUME_VIEWPORT_NEW_VOLUME,
        fetchSliceData
      );
    };
  }, [mprViewportElements]);

  const setActive = () => {
    setActiveMPRViewportIndex(viewportIndex);
    if (activeMPRTool) {
      setToolOnActiveMPRViewport(
        viewportIndex,
        activeMPRTool,
        previousActiveMPRTool,
        viewportIndex
      );
    }
  };

  const onChange = (event) => {
    // if (activeMPRViewportIndex === viewportIndex) {
    const intValue = parseInt(event.target.value, 10);
    setCurrentImage(intValue);
    // }
  };

  const onKeyPress = (event) => {
    const keyCode = event.which;

    switch (keyCode) {
      case 38: //UP
        if (currentImage != 0) {
          setCurrentImage(currentImage - 1);
        }
        break;
      case 40: //DOWN
        if (currentImage != imageCount - 1) {
          setCurrentImage(currentImage + 1);
        }
        break;
    }
  };

  // const onWheel = (event) => {
  //   const delta = Math.sign(event.deltaY);
  //   if (activeMPRViewportIndex === viewportIndex) {
  //     if (delta < 0 && currentImage === 1) return;
  //     if (delta >= 0 && currentImage === imageCount) return;
  //     setCurrentImage(currentImage + delta);
  //   }
  // };

  useEffect(() => {
    if (isMPRActive && isMPRViewportActivate) {
      jumpToSlice(mprViewportElements[orientation], {
        imageIndex: currentImage,
      });
    }
  }, [currentImage]);

  useEffect(() => {
    setCurrentImage(0);
  }, [activeMPRThumbnailIndex]);

  const handleDrop = async (e) => {
    setActive();
    const thumbnailIndex = e.dataTransfer.getData("thumbnailIndex");
    const series = e.dataTransfer.getData("series");
    const study = e.dataTransfer.getData("study");
    const modality = e.dataTransfer.getData("modality");
    const patientId = e.dataTransfer.getData("patientId");
    const patientAge = e.dataTransfer.getData("patientAge");
    const studyIdDisplay = e.dataTransfer.getData("studyIdDisplay");
    const patientName = e.dataTransfer.getData("patientName");
    const studyDescription = e.dataTransfer.getData("studyDescription");
    const studyDate = e.dataTransfer.getData("studyDate");
    const orderId = e.dataTransfer.getData("orderId");
    setMPRViewportLoaderRunning(true);
    const isSeriesReconstructable = await isReconstructable(
      thumbnailIndex,
      "thumbnail"
    );
    if (!isSeriesReconstructable.value) {
      setMPRViewportLoaderRunning(false);
      showToastv2(TOAST_TYPE.ERROR, t("mpr.not-reconstructable"));
      // setShowToast((prev) => {
      //   return {
      //     ...prev,
      //     show: true,
      //     message: t("mpr.not-reconstructable"),
      //     loading: false,
      //     state: "error",
      //   };
      // });
      return;
    }
    setActiveMPRTool(WindowLevelTool.toolName);
    setIsMPRActive(true);
    setActiveMPRThumbnailIndex(thumbnailIndex);
    setTimeout(async () => {
      await loadMPR(
        thumbnailIndex,
        "thumbnail",
        series,
        setMprLoading,
        setMprViewportElements,
        setIsMPRViewportActivated,
        setVolumeId
      );

      setMprSeriesData({
        study,
        series,
        modality,
        patientAge,
        patientId,
        studyIdDisplay,
        studyDate,
        modality,
        patientName,
        studyDescription,
        orderId,
      });

      updateInitialVOI();
      const viewport = await getMPRViewport(0);
  if (viewport?.voiRange) {
    setInitialVOI({
      windowWidth: viewport.voiRange.windowWidth,
      windowCenter: viewport.voiRange.windowCenter,
    });
  }
    }, 1500);

    enableVOISync();
    setCurrentImage(0);
  };

  const playCINE = async () => {
    const element = $("#viewport_" + orientation).find("#viewportEntry")[0];
    cine.playClip(element, { framesPerSecond: cINEFramesPerSecond });
  };

  const pauseCINE = async () => {
    const element = $("#viewport_" + orientation).find("#viewportEntry")[0];
    cine.stopClip(element);
  };

  useEffect(() => {
    if (activeMPRViewportIndex === viewportIndex) {
      if (isMPRCineEnabled) {
        if (viewportLevelCINEEnabled) {
          playCINE();
        } else {
          pauseCINE();
        }
      } else {
        setViewportLevelCINEEnabled(true);
        pauseCINE();
      }
    } else {
      if (viewportLevelCINEEnabled) {
        pauseCINE();
        setViewportLevelCINEEnabled(true);
      }
    }
  }, [
    activeMPRViewportIndex,
    isMPRCineEnabled,
    cINEFramesPerSecond,
    viewportLevelCINEEnabled,
  ]);
  //const [sliderValue, setSliderValue] = useState(0.1); 
  const presetValues = [ 5, 10, 15, 25, 50, 100, 200, 600];
  const slabOptions = [
    { label: 'Default', value: 0.05 },
    { label: '5 mm', value: 5 },
    { label: '10 mm', value: 10 },
    { label: '15 mm', value: 15 },
    { label: '25 mm', value: 25 },
    { label: '50 mm', value: 50 },
    { label: '100 mm', value: 100 },
    { label: '200 mm', value: 200 },
    { label: '600 mm', value: 600 }
  ];
  const [selectedPreset, setSelectedPreset] = useState('Default');
  const [selectedBlendMode, setSelectedBlendMode] = useState("MIP");
  const blendModeMap = {
    MIP: Enums.BlendModes.MAXIMUM_INTENSITY_BLEND,
    MinIP: Enums.BlendModes.MINIMUM_INTENSITY_BLEND,
    AVG: Enums.BlendModes.AVERAGE_INTENSITY_BLEND,
  };
  const isInternalSlabUpdate = useRef(false);

  useEffect(() => {
    //DOM element correspond to the current MPR viewport[Axial,Coronal,Sagittal]
    const element = mprViewportElements[orientation];

    if (!element) {
      console.warn('MPRViewport: No element found for orientation', orientation);
      return;
    }
    //run when the CAMERA_MODIFIED event happens
    const handleCameraModified = async (event) => {
      if (isInternalSlabUpdate.current) return;

      //Viewport obj contains images, camera and slab thickness
      const viewport = await getMPRViewport(viewportIndex);
      console.log("Viewport inside the handleCameraModified",viewport);
      console.log("Viewport getSlabThickness method",viewport.getSlabThickness);
      if (viewport) {
        //Fetch the latest slab thickness
        const newSlabThicknessDrag = viewport.getSlabThickness();
        //Only update if the difference value is more than 0.01 mm 
        const diffValue = 0.01;
        // if (Math.abs(newSlabThicknessDrag - sliderValue) > diffValue) {
        //   console.log("Slab thickness changed by dragging: ", newSlabThicknessDrag);
        //   setSliderValue(newSlabThicknessDrag);
        // }
        if (Math.abs(newSlabThicknessDrag - sharedSlabThickness) > 0.01) {
          updateSlabThickness(newSlabThicknessDrag);  // This syncs all viewports
        }
      }
    };
    //listen to any change in camera/slab thickness
    element.addEventListener(Enums.Events.CAMERA_MODIFIED, handleCameraModified);

    return () => {
      element.removeEventListener(Enums.Events.CAMERA_MODIFIED, handleCameraModified);
    };
  }, [mprViewportElements, orientation, viewportIndex,sharedSlabThickness]);

  const updateSlabThickness = (value) => {
    isInternalSlabUpdate.current = true; // prevent loop

    setSharedSlabThickness(value);
    ["axial", "coronal", "sagittal"].forEach((viewportName) => {
      const element = mprViewportElements[viewportName];
      const enabledElement = getEnabledElement(element);
      const viewport = enabledElement?.viewport;
      if (viewport?.setSlabThickness) {
        viewport.setSlabThickness(value);
        viewport.render();
      }
    });
    // allow sync again after a short delay
  setTimeout(() => {
    isInternalSlabUpdate.current = false;
  }, 100);
  };

  const updateBlendMode = (mode) => {
    setSharedMprBlendMode(mode);
    ["axial", "coronal", "sagittal"].forEach((viewportName) => {
      const element = mprViewportElements[viewportName];
      const enabledElement = getEnabledElement(element);
      const viewport = enabledElement?.viewport;
      if (viewport?.setBlendMode) {
        viewport.setBlendMode(blendModeMap[mode]);
        viewport.render();
      }
    });
  };
  //Reset slabthickness and mpr mode when the new series load into MPR mode
  useEffect(() => {
  if (mprSeriesData) {
    // Reset slab thickness to default when a new series loads
    const defaultSlabThickness = 0.1;
    const defaultBlendMode = "MIP";


    setSharedSlabThickness(defaultSlabThickness);
    setSharedMprBlendMode(defaultBlendMode);

    // Also apply it to all viewports
    ["axial", "coronal", "sagittal"].forEach((viewportName) => {
      const element = mprViewportElements[viewportName];
      const enabledElement = getEnabledElement(element);
      const viewport = enabledElement?.viewport;
      if (viewport?.setSlabThickness) {
        viewport.setSlabThickness(defaultSlabThickness);
        viewport.render();
      }
    });
  }
}, [mprSeriesData]);


  return (
    <div className="mpr-viewport-parent-container h100 w100">
      <div className="h100 w100 mpr-viewport-container">
        {contextMenuOpen.open && (
          <ContextMenu
            mouseEvt={contextMenuOpen.mouseEvt}
            data={contextMenuOpen.data}
          />
        )}
        <div
          id={`viewport_${orientation}`}
          className="viewport-box cursor-pointer h100 w100"
          // onWheel={onWheel}
          onKeyDown={onKeyPress}
          onClick={setActive}
        >
          <div
            ref={elementRef}
            id="viewportEntry"
            className="viewport-canvas h100 w100"
            onDrop={handleDrop}
            onDragOver={(e) => {
              e.preventDefault();
            }}
          ></div>
          {isEnabledSlabThickness && (
          <div
            style={{
              position: "absolute",
              bottom: "-4px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 9999,
              backgroundColor: "rgba(0, 0, 0, 0)",
              padding: "1px 1px",
              borderRadius: "2px",
              color: "#C1C1C1",
              fontSize: "11px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            {/* === First Row: Slab Thickness Dropdown (Left) and MIP Mode Dropdown (Right) === */}
            <div style={{ display: 'flex', justifyContent: 'space-between',  width: '140px', gap: '5px' }}>
              {/* Slab Thickness Dropdown */}
                <select
                  //value={sliderValue}
                  value={sharedSlabThickness}

                  onChange={(e) => {
                    const newValue = parseFloat(e.target.value);
                    //setSliderValue(newValue);
                    updateSlabThickness(newValue);
                  }}
                >
                  {/* Always show the current slider value on top */}
                  {/* <option value={sliderValue}>{sliderValue} mm</option> */}
                  {!slabOptions.some(opt => opt.value === sharedSlabThickness) && (
                    <option value={sharedSlabThickness}>{sharedSlabThickness.toFixed(2)} mm</option>
                  )}
                  {/* Show all predefined slab thickness presets, excluding duplicate */}
                    {slabOptions.map(({ label, value }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                </select>

              {/* MIP Mode Dropdown */}
              <select
                value={sharedMprBlendMode}
                onChange={(e) => {
                  const mode = e.target.value;
                  updateBlendMode(mode);
                }}
              >
                <option value="MIP">MIP</option>
                <option value="MinIP">MinIP</option>
                <option value="AVG">AVG</option>
              </select>
              </div>
              {/* === Second Row: Slab Thickness Slider === */}
              <label style ={{marginTop: "6px"}}>
              
            {/* <span style={{ marginBottom: "-2px" }}>Slab Thickness</span> */}
            <input
                type="range"
                // value={sliderValue}
                value={sharedSlabThickness}
                min="0.1"
                max="600"
                step="1"
                style={{ width: "150px" }}
                //defaultValue="0"
                onChange={(e) => {
                  let newValue = parseFloat(e.target.value);  //new value to slider[string to float]
                  const snapValue = 0.1;
                  const threshold = 0.5;

                  if (Math.abs(newValue - snapValue) < threshold) {
                    newValue = snapValue;
                  }
                  updateSlabThickness(newValue);

                }}
                //style={{ width: "100px" }}
              />
            </label>
          </div>
          )}
          {mprViewportLoaderRunning && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                zIndex: "99999",
                position: "absolute",
                top: "0",
              }}
            >
              <Spinner size={15} />
            </div>
          )}
          <ImageScrollbar
            max={imageCount - 1}
            value={currentImage}
            onChange={onChange}
            onKeyPress={onKeyPress}
            height={scrollbarHeight}
            elementRef={elementRef}
          />
          {showOverlay && (
            <>
              <PatientDetails viewportData={mprSeriesData} />
              <StudyDetails viewportData={mprSeriesData} isMPR={true} />
              <SeriesDetails
                viewportData={mprSeriesData}
                currentImage={currentImage}
                totalImage={imageCount - 1}
              />
              <DICOMDetails voi={voi} scale={scale} orientation={orientation} />
              <OrientationMarkers markers={markers} />
            </>
          )}
          {isMPRCineEnabled && activeMPRViewportIndex === viewportIndex && (
            <>
              <div className="viewport-cine-container">
                <div className="viewport-cine-box">
                  <span
                    className="viewport-cine-button"
                    style={{ marginRight: "10px" }}
                    onClick={() =>
                      setViewportLevelCINEEnabled(!viewportLevelCINEEnabled)
                    }
                  >
                    {viewportLevelCINEEnabled ? (
                      <CINEPauseSmall />
                    ) : (
                      <CINEPlaySmall />
                    )}
                  </span>
                  <span
                    className={`viewport-cine-button ${
                      cINEFramesPerSecond === 1
                        ? "viewport-cine-button-disabled"
                        : ""
                    }`}
                    onClick={() => {
                      if (cINEFramesPerSecond !== 1) {
                        setCINEFramesPerSecond(cINEFramesPerSecond - 1);
                      }
                    }}
                  >
                    {" "}
                    <CINEMinus />{" "}
                  </span>
                  <span style={{color:"#ffffff"}}> {cINEFramesPerSecond} </span>
                  <span
                    className="viewport-cine-button"
                    onClick={() =>
                      setCINEFramesPerSecond(cINEFramesPerSecond + 1)
                    }
                  >
                    {" "}
                    <CINEPlus />{" "}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MPRViewport;
